<template>
  <GridRow>
    <div class="apo-360-box">
      <a
        class="apo-360-box__content"
        href="https://360.apoverlag.at"
        target="_blank"
        rel="noopener noreferrer"
        :aria-label="box.attributes.templateOptions.title"
      >
        <figure class="apo-360-box__image">
          <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.46 147.26">
            <title>360 Grad Apoverlag - Grafik</title>
            <defs>
              <style>
                .cls-1 {
                  fill: #1d1d1b;
                }
              </style>
            </defs>
            <path
              class="cls-1"
              d="M270.79,2.63c-6.75,0-12.67,6.1-12.67,13.05s5.92,13.05,12.67,13.05,12.67-5.98,12.67-13.05-5.92-13.05-12.67-13.05ZM270.79,25.51c-5.03,0-9.45-4.6-9.45-9.83s4.42-9.83,9.45-9.83,9.46,4.6,9.46,9.83-4.33,9.83-9.46,9.83Z"
            />
            <path
              class="cls-1"
              d="M203.98,0c-25.63,0-52.79,18.12-53.49,51.69-7.07-4.83-15.58-7.62-24.95-7.62-1.37,0-2.64,0-3.91.13l28.65-39.02c.36-.49.41-1.14.14-1.68-.27-.54-.83-.88-1.43-.88h-41.07c-.53,0-1.03.26-1.33.7l-12.78,18.76C86.83,8.66,71.69,0,52.81,0c-14.9,0-28.02,4.97-36.95,14C7.81,22.15,3.62,32.98,3.76,45.34c.01.88.73,1.59,1.61,1.59h74.53c.53,0,1.03-.26,1.33-.7l11.86-17.4c1.06,3.34,1.63,6.91,1.63,10.67,0,12.43-5.73,21.47-17.52,27.65-.57.3-.9.9-.85,1.54.05.64.47,1.19,1.07,1.4,16.35,5.69,24.99,16.77,24.99,32.05,0,13.24-7.34,25.07-18.76,32.75-10.92-7.43-18.34-19.03-20.62-33.49-.12-.78-.8-1.36-1.59-1.36l-59.82-.08c-.44,0-.86.18-1.16.49s-.47.75-.45,1.18c1.5,33.67,29.29,45.61,52.62,45.61,11.63,0,22.4-3.21,31.15-8.64,8.88,5.54,19.69,8.64,31.63,8.64,18.94,0,35.04-8.46,44.94-21.89,9.61,13.42,25.4,21.89,44.01,21.89,30.6,0,52.81-22.52,52.81-53.56v-41.07c0-30-22.87-52.62-53.18-52.62ZM79.05,43.71H6.98c.23-10.82,4.07-20.28,11.17-27.45C26.47,7.85,38.78,3.22,52.81,3.22c18.31,0,32.83,8.68,38.87,21.96l-12.64,18.54ZM52.62,144.04c-21.52,0-47.07-10.74-49.31-40.86l56.76.08c2.56,14.06,10.02,25.64,20.75,33.38-8.02,4.66-17.74,7.39-28.21,7.39ZM153.63,58.41c8.66,8.21,13.99,20.33,13.99,34.35,0,9.99-2.67,19.11-7.32,26.84-4.17-7.15-6.67-15.8-6.67-25.9v-35.29ZM115.4,144.04c-10.9,0-20.69-2.58-28.81-7.3,11.63-8.29,19.03-20.72,19.03-34.61,0-15.73-8.25-27.38-23.91-33.86,10.91-6.71,16.22-16.16,16.22-28.78,0-4.99-.9-9.69-2.59-13.98l13.41-19.67h37.05l-28.69,39.07c-.4.55-.41,1.29-.04,1.85l.38.56c.4.6,1.15.86,1.84.63,2.01-.67,3.88-.67,6.24-.67,9.47,0,18,3.08,24.89,8.37v38.04c0,10.78,2.94,20.58,8.02,28.81-9.26,13.2-24.75,21.54-43.04,21.54ZM253.94,93.7c0,33.05-24.95,50.34-49.59,50.34-15.89,0-32.37-7.41-42.09-21.44,5.44-8.47,8.57-18.65,8.57-29.84,0-16.14-6.61-29.93-17.2-38.68v-1.08c0-32.33,25.94-49.78,50.34-49.78,28.48,0,49.97,21.24,49.97,49.41v41.07Z"
            />
          </svg>
        </figure>
        <p>
          {{ box.attributes.templateOptions.title }}
        </p>
      </a>
    </div>
  </GridRow>
</template>

<script>
import GridRow from '@/components/ui/grid/row'

export default {
  components: {
    GridRow,
  },
  props: {
    box: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss">
@import '../../../../css/import/vars';

.apo-360-box {
  width: 100%;
  max-width: $page-max-width;
  margin: auto;

  &__image {
    display: flex;
    justify-content: center;
    margin-bottom: 1.5rem;

    svg {
      max-width: 250px;
      width: 100%;
    }
  }

  &__content {
    width: 100%;
    max-width: 1040px;
    padding: 1rem;
    margin: auto;
    text-align: center;
    color: #1f1f1f;

    p {
      font-size: 24px;
      font-weight: 200;
      font-variation-settings: 'wght' 200;
      padding: 0 15px;

      @media screen and (min-width: $screen-width-767) {
        font-size: 32px;
        padding: 0 30px;
      }
    }
  }
}
</style>
